import { render, staticRenderFns } from "./receipt-eft-details.vue?vue&type=template&id=44be5e50&scoped=true&lang=pug"
import script from "./receipt-eft-details.vue?vue&type=script&lang=js"
export * from "./receipt-eft-details.vue?vue&type=script&lang=js"
import style0 from "./receipt-eft-details.vue?vue&type=style&index=0&id=44be5e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be5e50",
  null
  
)

export default component.exports